import { updateBhTrackingContextValue } from './utils/bh-tracking-context'

export const addToWishlist = ({
	product,
	pageContext,
	pageId,
	widgetContext,
	getLocalStorageByGroup,
	setLocalStorageByGroup,
}) => {
	updateBhTrackingContextValue({
		product,
		pageContext,
		pageId,
		widgetContext,
		getLocalStorageByGroup,
		setLocalStorageByGroup,
	})
}
